
import { css } from 'lit';
export default css`
.monogram-panel__wrapper {
  position: relative;
}
  .monogram-panel__wrapper {
  display: grid;
}
  .monogram-panel__wrapper {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper {
    gap: 1.5rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__wrapper {
    gap: 0px;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__wrapper {
      -ms-grid-gap: 0
  }
    }
  @media (min-width: 768px) {
  .monogram-panel__wrapper--rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper--rows-2 .monogram-panel__card-wrapper {
    grid-row: span 2 / span 2;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper--rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper--rows-3 .monogram-panel__card-wrapper {
    grid-row: span 3 / span 3;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper--rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
}
  @media (min-width: 768px) {
  .monogram-panel__wrapper--rows-4 .monogram-panel__card-wrapper {
    grid-row: span 4 / span 4;
  }
}
  .monogram-panel__title-wrapper {
  position: relative;
}
  .monogram-panel__title-wrapper {
  grid-column: span 1 / span 1;
}
  .monogram-panel__title-wrapper {
  grid-row: span 1 / span 1;
}
  .monogram-panel__title-wrapper {
  margin-bottom: 0.75rem;
}
  .monogram-panel__title-wrapper {
  display: flex;
}
  .monogram-panel__title-wrapper {
  flex-shrink: 0;
}
  .monogram-panel__title-wrapper {
  flex-direction: row;
}
  .monogram-panel__title-wrapper {
  justify-content: space-between;
}
  .monogram-panel__title-wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
  .monogram-panel__title-wrapper {
  padding: 1rem;
}
  .monogram-panel__title-wrapper {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper {
    margin-bottom: 0px;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper {
    flex-direction: column;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__title-wrapper {
    padding-top: 2.5rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__title-wrapper {
      width: 224px
  }
    }
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper::before {
    position: absolute;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper::before {
    top: 0px;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper::before {
    z-index: -10;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper::before {
    height: 100%;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper::before {
    --tw-bg-opacity: 1;
    background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  }
}
  @media (min-width: 768px) {
  .monogram-panel__title-wrapper::before {
        content: ' ';
        width: calc(54px + 10rem);
        transform: translateX(-100%)
    }
      }
  .monogram-panel__icon {
  margin-bottom: -2rem;
}
  .monogram-panel__icon {
  height: 7rem;
}
  .monogram-panel__icon {
  width: 7rem;
}
  .monogram-panel__icon {
  flex-shrink: 0;
}
  .monogram-panel__icon {
  align-self: flex-end;
}
  .monogram-panel__icon {
  fill: currentColor;
}
  @media (min-width: 768px) {
  .monogram-panel__icon {
    margin-bottom: -2.5rem;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__icon {
    height: 10rem;
  }
}
  @media (min-width: 768px) {
  .monogram-panel__icon {
    width: 10rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__icon {
    position: relative;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__icon {
    margin-bottom: -3rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__icon {
    margin-left: -2.5rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__icon {
    height: 12rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__icon {
    width: 12rem;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__icon {
    align-self: flex-start;
  }
}
  .monogram-panel__title {
  align-self: center;
}
  @media (min-width: 768px) {
  .monogram-panel__title {
    margin-bottom: 2rem;
  }
}
  .monogram-panel__card-wrapper {
  display: flex;
}
  .monogram-panel__card-wrapper {
  flex-direction: column;
}
  @media (min-width: 768px) {
  .monogram-panel__card-wrapper {
    grid-column: span 3 / span 3;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card-wrapper {
    flex-direction: row;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card-wrapper {
    flex-wrap: wrap;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card-wrapper {
    padding-top: 3rem;
  }
}
  .monogram-panel__card {
  position: relative;
}
  .monogram-panel__card {
  display: flex;
}
  .monogram-panel__card {
  align-items: flex-start;
}
  .monogram-panel__card {
  border-bottom-width: 1px;
}
  .monogram-panel__card {
  --tw-border-opacity: 1;
  border-color: rgba(216, 216, 216, var(--tw-border-opacity));
}
  .monogram-panel__card {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
  .monogram-panel__card:last-child {
  border-bottom-width: 0px;
}
  @media (min-width: 768px) {
  .monogram-panel__card:first-child {
    padding-top: 0px;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card {
    width: 33.333333%;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card {
    border-width: 0px;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card {
    padding-bottom: 1rem;
  }
}
  /* First Three */
  @media (min-width: 1024px) {
  .monogram-panel__card:nth-child(-n + 3) {
    padding-top: 0px;
  }
}
  .monogram-panel__card + .monogram-panel__card:before {
        content: ''
      }
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
    position: absolute;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
    left: 0px;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
    display: flex;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
    width: 1px;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
    --tw-bg-opacity: 1;
    background-color: rgba(216, 216, 216, var(--tw-bg-opacity));
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
    opacity: 0.6;
  }
}
  @media (min-width: 1024px) {
  .monogram-panel__card + .monogram-panel__card:before {
          height: calc(100% - 1rem)
      }
        }
`;